import axios, { AxiosRequestConfig } from "axios";
import { RootURL } from "./Globals";
import { buildFormData } from "./buildFormData";

export type BaseResponse = {
  success?: boolean;
  message?: string;
  errors?: string[];
};

export type HttpOptions = {
  url: string;
  data?: any;
  onUploadProgress?: (percentage: number) => void;
  useFormData?: boolean;
};

axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

async function get<TResponse>(
  options: HttpOptions
): Promise<TResponse & BaseResponse> {
  const url = RootURL + options.url;
  //attach cache-busting to the params
  const params = { ...options.data, _: `${new Date().getTime()}` };
  const res = await axios.get(url, { params });
  return res.data as TResponse;
}

async function post<TResponse>(
  options: HttpOptions
): Promise<TResponse & BaseResponse> {
  let config: AxiosRequestConfig = {};

  //if we get an upload progress callback, attach it to axios config
  const onUploadProgressCallback = options.onUploadProgress;
  if (onUploadProgressCallback) {
    config.onUploadProgress = function (progressEvent: any) {
      const percentage = (progressEvent.loaded * 100) / progressEvent.total;
      onUploadProgressCallback(percentage);
    };
  }

  //if the caller wants formData instead of json,
  //and they supplied us a regular Object instead of a FormData
  //change axios headers and build the form data from the object
  let postData: any;
  if (options.useFormData && !!(options.data instanceof FormData)) {
    let formData = new FormData();
    buildFormData(options.data, formData);
    postData = formData;
    config.headers = { "Content-Type": "multipart/form-data" };
  } else {
    postData = options.data;
  }

  //build url with the RootURL from window
  const url = RootURL + options.url;

  const res = await axios.post(url, postData, config);
  return res.data as TResponse;
}

export const Http = {
  get,
  post,
  openNewTab,
  resolveClientUrlWithoutSessionToken,
};

function openNewTab(partialUrl: string) {
  const url = resolveClientUrlWithoutSessionToken(partialUrl);
  open(url, "_blank");
}

function getRootUrlWithoutSessionToken() {
  try {
    const urlParts = new URL(RootURL);
    const pathName = urlParts.pathname.split("/", 2).pop();
    return `${urlParts.origin}/${pathName}/`;
  } catch {
    return "";
  }
}
function resolveClientUrl(partialUrl: string) {
  return RootURL + partialUrl;
}
function resolveClientUrlWithoutSessionToken(partialUrl: string) {
  return getRootUrlWithoutSessionToken() + partialUrl;
}
function open(url: string, target?: string) {
  window.open(url, target || "_self");
}
